<template>
  <section class="myOrder">
    <SidebarAccount />

    <div class="resume">
    <a-skeleton :loading="loading" active> </a-skeleton>
      <div class="infos" v-for="(dados, i) in infos" :key="i">
        <div
          class="infos__card"
          v-for="(pgmt, i) in dados.frmPagamento"
          :key="i"
        >
          <p class="infos__title">Forma de Pagamento</p>
          <p class="infos__description">{{ pgmt.dsformapgto }}</p>
          <p
            class="infos__description"
            v-if="
              pgmt.cdFormapgto == 4 ||
              pgmt.cdFormapgto == 2 ||
              pgmt.cdFormapgto == 9 ||
              pgmt.cdFormapgto == 8
            "
          >
            {{ pgmt.firstDigits }}*****{{ pgmt.lastDigits }}
          </p>
          <p class="infos__description">
            {{ pgmt.nrparcela }}x de
            {{ (pgmt.vlTotal / pgmt.nrparcela) | toCurrency }}
          </p>
        </div>
        <div class="infos__card">
          <p class="infos__title">Valor pago</p>
          <div class="infos__valores">
            <p class="infos__description">Subtotal</p>
            <p class="infos__description">{{ dados.vlBruto | toCurrency }}</p>
          </div>
          <div class="infos__valores">
            <p class="infos__description">Frete</p>
            <p class="infos__description">
              {{ dados.vltotalfrete | toCurrency }}
            </p>
          </div>
          <div class="infos__valores">
            <p class="infos__description">Descontos</p>
            <p class="infos__description">
              {{ dados.vlDesconto | toCurrency }}
            </p>
          </div>
          <div class="infos__total">
            <p class="infos__description infos__description--bold">Total</p>
            <p class="infos__description infos__description--bold">
              {{ (dados.vlliquido + dados.vltotalfrete) | toCurrency }}
            </p>
          </div>
        </div>
        <div class="infos__card">
          <p class="infos__title">Endereço</p>
          <h3 class="infos__clientName">
            {{ dados.dadosCliente.nmcliente_razao }}
          </h3>
          <p class="infos__description">
            {{ dados.dadosCliente.logradouro }} -
            {{ dados.dadosCliente.nrresidencia }}
          </p>
          <p class="infos__description">{{ dados.dadosCliente.bairro }}</p>
          <p class="infos__description">{{ dados.dadosCliente.complemento }}</p>
          <p class="infos__description">{{ dados.dadosCliente.cep }}</p>
          <p class="infos__description">
            {{ dados.dadosCliente.cidade }} - {{ dados.dadosCliente.uf }}
          </p>
        </div>
      </div>

      <div class="orders" v-for="(info, i) in infos" :key="i">
        <div class="verify" v-if="info.NRPedido.slice(0, 1) != 'v'">
          <div class="header">
            <div class="header__item">
              <p class="item__text">Pedido</p>
              <p class="item__text">{{ info.NRPedido }}</p>
            </div>
            <div class="header__item">
              <p class="item__text">Data do Pedido</p>
              <p class="item__text">
                {{ moment(info.dtPedido).format("DD/MM/YYYY HH:mm:ss") }}
              </p>
            </div>
            <div class="header__item header__item--status">
              <p
                class="header__orderStatus header__orderStatus--billed"
                v-if="info.StatusPedido == 'FATURADO'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--canceled"
                v-if="info.StatusPedido == 'CANCELADO'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--pending"
                v-if="info.StatusPedido == 'PENDENTE'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--finished"
                v-if="info.StatusPedido == 'ENTREGUE'"
              >
                {{ info.StatusPedido }}
              </p>
              <p
                class="header__orderStatus header__orderStatus--approved"
                v-if="info.StatusPedido == 'APROVADO'"
              >
                {{ info.StatusPedido }}
              </p>
            </div>
          </div>
          <div class="body">
            <div class="subTable" v-for="(itens, i) in info.cjPedido" :key="i">
              <router-link to="" v-if="itens.urlImagem != null">
                <img
                  :src="itens.urlImagem"
                  :alt="itens.dsConjunto"
                  width="70px"
              /></router-link>
              <router-link to="" v-if="itens.urlImagem == null">
                <img
                  src="../../../assets/produto-sem-imagem.jpg"
                  :alt="itens.dsConjunto"
                  width="70px"
                />
              </router-link>
              <div class="subTable__infos">
                <router-link to="" class="infos__text--link">
                  {{ itens.dsConjunto }}
                </router-link>
                <p class="infos__text" v-if="(itens.qtd = 1)">
                  {{ itens.qtd }} Unidade
                </p>
                <p class="infos__text" v-if="itens.qtd > 1">
                  {{ itens.qtd }} Unidades
                </p>
                <p class="infos__text">
                  Vendido e Entregue por
                  <span class="infos__text--color">Leveros</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SidebarAccount from "../SidebarAccount";
import axios from "axios";
export default {
  data() {
    return {
      infos: [],
      itensPedido: [],
      token: null,
      loading: false,
    };
  },
  components: {
    SidebarAccount,
  },
  methods: {
    async getDados() {
      try {
        let dados = JSON.parse(localStorage.getItem("login"));

        if (dados != undefined) {
          this.token = dados.token;
        } else {
          this.token = "";
        }

        var url = new URL(window.location.href);
        var order = url.searchParams.get("Pedido");

        try {
          this.loading = true;
          const response = await axios.get(
            `https://www.leverosintegra.com.br/MAP/api/pedido/${order}-token${this.token}`
          );
          this.infos = response.data;
          this.loading = false;
          let itens = this.infos;

          itens.forEach(function (e) {
            if (e.cjPedido.length != -1) {
              itens = e.cjPedido;
            }
          });
          this.itensPedido = itens;
        } catch (e) {
          console.log(e);
        }
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
  },

  beforeMount() {
    this.getDados();
  },
};
</script>

<style lang="scss" scoped>
.myOrder {
  display: flex;
  margin: 0 auto;
  padding-top: 60px;
  max-width: 100%;
  flex-direction: column;

  @media (min-width: 441px) {
    max-width: 85%;
    flex-direction: row;
  }

  @media (min-width: 1920px) {
    max-width: 65%;
    flex-direction: row;
  }
}

.resume {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding-top: 40px;

  @media (min-width: 441px) {
    width: 80%;
    padding-top: 0;
  }
}

.infos {
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @media (min-width: 441px) {
    flex-direction: row;
  }

  &__card {
    box-shadow: 0 4px 10px var(--customGray-100);
    padding: 20px;
    border-radius: 5px;
    width: 100%;
    margin-bottom: 25px;

    @media (min-width: 441px) and (max-width: 768px) {
      width: 45%;
      margin: 10px;
    }

    @media (min-width: 769px) {
      width: 30%;
      margin-bottom: 0;
    }
  }

  &__title {
    color: var(--customGray-500);
    font: 700 1.2rem "Soleto", sans-serif;
    padding-bottom: 15px;
  }

  &__description {
    color: var(--customGray-500);
    font-size: 1rem;
    line-height: 1.6;

    &--bold {
      color: #0a0a0a;
    }
  }

  &__clientName {
    font-size: 1.1rem;
    padding-bottom: 20px;
  }

  &__valores,
  &__total {
    display: flex;
    justify-content: space-between;
  }

  &__total {
    border-top: 1px solid var(--customGray-100);
  }
}
.orders {
  margin: 20px 0;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--customGray-70);
    border-radius: 5px;
    padding: 15px 5px;
    margin-bottom: 10px;

    &__item {
      display: flex;
      flex-direction: column;
      width: initial;

      @media (min-width: 441px) {
        width: 25%;
      }

      .item {
        &__text:first-child {
          font-weight: bold;
        }

        &__text {
          font-size: 0.95rem;
        }
      }

      &--status {
        width: initial;
        display: flex;
        flex-direction: column;

        @media (min-width: 441px) {
          width: 10%;
        }

        p:first-child {
          font: 700 0.85rem "Soleto", sans-serif;
        }
      }
    }

    &__orderStatus {
      color: var(--customWhite);
      padding: 5px;
      border-radius: 5px;
      font: 700 0.85rem "Soleto", sans-serif;
      text-align: center;

      &--billed {
        background: #0694cc;
      }

      &--approved {
        background: #019231;
      }

      &--canceled {
        background: #be2323;
      }

      &--pending {
        background: #ec9420;
      }

      &--finished {
        background: #0694cc;
      }
    }
  }

  .body {
    border-bottom: 1px solid var(--customGray-100);
  }

  .subTable {
    display: flex;
    align-items: center;
    padding-bottom: 40px;

    &__infos {
      display: flex;
      flex-direction: column;
      line-height: 1.9;
      padding-left: 25px;
      color: var(--customGray-500);

      .infos {
        &__text {
          font-size: 0.95rem;

          &--link {
            color: var(--customDarkGreen);
            text-decoration: none;
            font: 700 0.95rem "Soleto", sans-serif;
            padding-bottom: 10px;
          }

          &--color {
            color: var(--standardGreen);
            font: 700 0.95rem "Soleto", sans-serif;
          }
        }

        &__text:last-child {
          &--link {
            text-decoration: underline;

            svg {
              vertical-align: middle;
              margin-right: 7px;
            }
          }
        }
      }
    }
  }
}
</style>